// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host img {
  display: block;
}
:host.square {
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}
:host.square img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; /* This makes the image fill the square box created by the parent div */
  object-fit: fill; /* This makes the image cover the entire space without distorting the aspect ratio */
}
:host.fill {
  display: block;
  height: 100%;
  position: relative;
  overflow: hidden;
}
:host.fill img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 170%;
  max-height: 170%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-secured-image/ax-secured-image.component.scss"],"names":[],"mappings":"AACE;EACE,cAAA;AAAJ;AAGE;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AADJ;AAGI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA,EAAA,uEAAA;EACA,gBAAA,EAAA,oFAAA;AADN;AAKE;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAHJ;AAKI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;AAHN","sourcesContent":[":host {\n  img {\n    display: block;\n  }\n\n  &.square {\n    display: block;\n    width: 100%;\n    height: 0;\n    padding-bottom: 100%;\n    position: relative;\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%; /* This makes the image fill the square box created by the parent div */\n      object-fit: fill; /* This makes the image cover the entire space without distorting the aspect ratio */\n    }\n  }\n\n  &.fill {\n    display: block;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n\n    img {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      max-width: 170%;\n      max-height: 170%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
